module.exports = __webpack_public_path__ + "static/media/loading.be766a06.gif";